import React from "react";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
function PlanExpired({ subscriptionStatus, daysLeft }) {
  const isLaptop = useMediaQuery({ query: "(max-width: 1350px)" });

  return (
    <div className="flex plan-expired flex align-center space-between ">
      <div className="full-width align-center flex">
        <span className="flex align-center justify-center announcement-banner">
          <b className="white-text">
            {subscriptionStatus === "expired"
              ? "Your Plan Expired"
              : "Your Plan Will Expire Soon"}
          </b>
        </span>

        <span className="announcement-banner-title">&nbsp;</span>

        <b className={`${isLaptop ? "p-1 font-14px" : "p-2"}`}>
          <span className="announcement-banner-message">
            {subscriptionStatus === "expired"
              ? `Your plan has expired.${
                  isLaptop
                    ? ""
                    : " Please upgrade to continue using our services."
                }`
              : `Your plan will expire ${
                  daysLeft === 0
                    ? "on today"
                    : daysLeft === 1
                    ? "on tomorrow"
                    : `in ${daysLeft} days`
                }.${
                  isLaptop ? "" : " Please renew to continue using our services."
                }`}
          </span>
        </b>
      </div>

      <Link
        className=""
        style={{
          width: "130px",
          marginRight: "10px",
        }}
        to="/subscription"
      >
        Upgrade Now
      </Link>
    </div>
  );
}

export default PlanExpired;
